export default "__VITE_ASSET__CC78x04g__"